export default "__VITE_ASSET__Dg8z4i_W__"